import createReactComponent from '../createReactComponent';
export default createReactComponent('repeat', 'IconRepeat', [
  ['path', { d: 'M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3', key: 'svg-0' }],
  ['path', { d: 'M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3', key: 'svg-1' }],
]);
